// extracted by mini-css-extract-plugin
module.exports = {"root":"styles-module--root--2sJsa","spin":"styles-module--spin--2pMIB"};